import React, {useRef} from 'react';
import { AuthContext } from "../../../authContext";

import AppContent from "../../shared/AppContent";
import Flex from "../../shared/Flex";
import WebLink from "../../shared/WebLink";
import BreadcrumbSeparator from "../../shared/BreadcrumbSeparator";
import { getAnalysis } from "../../data/dataCIMToolkit";

import Map from '../../../components/shared/Map';

class UrbanContext extends React.Component {
    state = {
        btnMessage: "Run analysis",
        data: null,
        isRunning: false
    }
    static contextType = AuthContext;

    componentDidMount() {
        if (!this.context.isLoggedIn) {
            this.context.navigate('/');
        }

        /*
         * Listen for upload completion, so analysis can run once model is uploaded.
         */
        let oldTitle = document.title;
        const doAnalysis = this.doAnalysis;

        this.checkForTitleChanges = setInterval(async () => {
            let str = document.title;
            if (str !== oldTitle) {
                oldTitle = str;

                let titleParts = str.split('|');

                if (str !== "CityCAD Online")
                    await this.setState({ msg: `Response is ${str}`} )

                if (titleParts[0] === "citycad") {
                    doAnalysis(titleParts[4])
                }
            }
        }, 100);
    }

    componentWillUnmount() {
        clearInterval(this.checkForTitleChanges);
    }

    beginAnalysis = async () => {
        console.log("Beginning analysis...")

        //await this.doAnalysis(146);

        // if (this.state.isRunning === true)
        //   return null;
        // await this.setState({ isRunning: true, btnMessage: 'Uploading URB model'} )
        // console.log("Should be running analysis")
        //
        // // Create new resource
        // const newResourceData = {
        //   name: `analysis-model.curb`,
        //   projectID: 21,
        //   type: 'application/urb'
        // };
        //
        // console.log("About to add resource", newResourceData)
        // let addResourceResponse = await createProjectResource(newResourceData, this.context.token);
        //
        // const tempResourceID = Number(addResourceResponse.data.resourceID);
        // alert(`Resource created with ID ${tempResourceID} and file reference ${addResourceResponse.data.fileReference}`)
        //
        // await saveResource(tempResourceID, this.context.token)
        //
        // await this.setState({ isRunning: false, btnMessage: 'Running analysis'})


    }

    doAnalysis = async resourceID => {
        const analysisResult = await getAnalysis(resourceID, this.context.token);

        console.log("analysis result: ", analysisResult.data);
        await this.setState({
            data: analysisResult.data
        });

        await this.setState({ isRunning: false, btnMessage: 'Run analysis again'})
    }

    render() {
        return (
            <AppContent>
                <Flex justifyContent={`flex-start`}>
                    <WebLink onClick={() => this.context.navigate(`/analysis`)} >Analysis</WebLink>
                    <BreadcrumbSeparator />
                    <div>Urban Context</div>
                </Flex>

                <Map />


                {/*{*/}
                {/*    this.state.data !== null*/}
                {/*    &&*/}
                {/*    <UrbanContextData cityData={this.state.data} />*/}
                {/*}*/}
                {/*<Button*/}
                {/*    className="btn"*/}
                {/*    style={{*/}
                {/*        margin: "25px 0 14px 0",*/}
                {/*        padding: "14px 0",*/}
                {/*        width: "100%",*/}
                {/*        display: "flex",*/}
                {/*        justifyContent: "center",*/}
                {/*        alignItems: "center"*/}
                {/*    }}*/}
                {/*    onClick={this.beginAnalysis}*/}
                {/*>*/}
                {/*    {*/}
                {/*        this.state.isRunning*/}
                {/*        &&*/}
                {/*        <FiLoader*/}
                {/*            className={`icon-spin`}*/}
                {/*            style={{marginRight: "10px"}}*/}
                {/*        />*/}
                {/*    }*/}
                {/*    {*/}
                {/*        this.state.btnMessage*/}
                {/*    }*/}
                {/*</Button>*/}

            </AppContent>
        )
    }
}

export default UrbanContext;